module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "menu-item"
  }, [(_vm.thisStep < _vm.currentStep) ? _c('done-icon', {
    staticClass: "absolute",
    attrs: {
      "alt": "step"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thisStep === _vm.currentStep) ? _c('in-progress-icon', {
    staticClass: "absolute",
    attrs: {
      "alt": "step"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thisStep === _vm.ACTIVATION_CODE) ? _c('activation-icon', {
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), (_vm.thisStep === _vm.PERSONAL_INFO) ? _c('personal-icon', {
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), (_vm.thisStep === _vm.TERMS_CONDS) ? _c('terms-icon', {
    class: _vm.iconClass
  }) : _vm._e(), _vm._v(" "), _c('label', {
    class: _vm.labelStyle
  }, [_vm._v("\n      " + _vm._s(_vm.stepLabel) + "\n    ")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78c5f71e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c5f71e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/progressSideBar/ProgressStatus.vue
// module id = 678
// module chunks = 0